import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import { Check, CheckCircleOutline, ChevronDown, Reload, } from 'mdi-material-ui';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState } from 'react';
const options = [
    {
        value: 'approve',
        name: 'Approve',
        color: '#2F80ED',
        icon: _jsx(Check, { sx: { fontSize: 16 } }),
    },
    {
        value: 'request-changes',
        name: 'Request Changes ',
        color: 'black',
        icon: _jsx(Reload, { sx: { fontSize: 16 } }),
    },
    {
        value: 'approved',
        name: 'Approved',
        color: '#3DB280',
        icon: _jsx(CheckCircleOutline, { sx: { fontSize: 16 } }),
    },
    {
        value: 'changes-required',
        name: 'Changes Required',
        color: '#FF0000',
        icon: _jsx(Reload, { sx: { fontSize: 16 } }),
    },
];
const StatusDropdown = ({ plan, onChange, disabled = false, }) => {
    const [status, setStatus] = useState(('approved' in plan && options[2]) ||
        ('remarks' in plan && options[3]) ||
        options[0]);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        if (status.value === 'approved')
            return;
        if (status.value === 'changes-required')
            return onChange('changes-required');
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        setStatus(('approved' in plan && options[2]) ||
            ('remarks' in plan && options[3]) ||
            options[0]);
    }, [plan]);
    const handleSelect = (value) => {
        onChange(value.value);
        setAnchorEl(null);
        //if (value.value === 'approve') return setStatus(options[2]);
        //if(value.value ==="request-changes") return setStatus(options[3]);
    };
    let filteredOptions = [];
    if ('remarks' in plan || (plan === null || plan === void 0 ? void 0 : plan.approved)) {
        if ('approved' in plan) {
            filteredOptions.push(options[2]);
        }
        else {
            filteredOptions.push(options[3]);
        }
    }
    else {
        filteredOptions.push(options[0], options[1]);
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Button, Object.assign({ onClick: handleClick, disabled: disabled, sx: {
                    color: status.color,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '2px',
                    alignItems: 'center',
                    border: 1,
                    padding: 1,
                    borderRadius: '4px',
                    height: '32px',
                    minWidth: 'auto',
                } }, { children: [status.icon, _jsx(Typography, Object.assign({ variant: "subtitle2", color: disabled ? '#dedede' : status.color }, { children: status.name })), _jsx(ChevronDown, { sx: { fontSize: '16px' } })] })), _jsx(Menu, Object.assign({ anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                } }, { children: _jsx(Box, Object.assign({ sx: {
                        borderRadius: '8px',
                        boxShadow: '0px 0px 4px rgba(102, 102, 102, 0.25)',
                        margin: '4px',
                        p: '5px',
                    } }, { children: filteredOptions.map((item) => (_jsxs(MenuItem, Object.assign({ onClick: () => handleSelect(item), sx: {
                            color: item.color,
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 2,
                            fontSize: 14,
                        } }, { children: [item.icon, _jsx(Typography, Object.assign({ variant: "subtitle2", color: item.color }, { children: item.name }))] }), item.value))) })) }))] }));
};
export default StatusDropdown;
